import { Theme } from "@emotion/react";
import { Box, SxProps, Typography, useTheme } from "@mui/material";
import { FC } from "react";

interface EmptyStateProps {
  image?: React.ReactNode;
  title?: string;
  message?: string;
  button?: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const EmptyState: FC<EmptyStateProps> = ({ image, title, message, button, sx }) => {
  const theme = useTheme();
  return (
    <Box
      component="div"
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "stretch",
        alignItems: "center",
        flex: 1,
        overflowY: "auto",
        "& svg": {
          width: "240px",
          flexShrink: "0"
        },
        ...(sx ? sx : {})
      }}
    >
      <Box component="div" sx={{ flex: 1 }}></Box>
      {image}
      {title && (
        <Typography
          color={theme.surface.onVariant}
          variant={"h4"}
          fontWeight={500}
          textAlign={"center"}
          margin={"1em 0"}
          maxWidth={"540px"}
        >
          {title}
        </Typography>
      )}
      {message && (
        <Typography
          color={theme.surface.onVariant}
          sx={{ whiteSpace: "pre-line" }}
          fontWeight={400}
          variant={"body2"}
          textAlign={"center"}
          maxWidth={"540px"}
        >
          {message}
        </Typography>
      )}
      {button}
      <Box component="div" sx={{ flex: 1 }}></Box>
    </Box>
  );
};
